import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Conseguir alumnos de forma constante', 'Cobrar más sin perder demanda', 'Llenar su agenda sin depender de la suerte', 'Incluso generar ingresos fuera de la pista'];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4 bg-card/30" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <p className="text-xl md:text-2xl text-center mb-8" data-id="element-161">
          Hoy, un pequeño grupo de profesores de pádel está haciendo algo
          diferente…
        </p>

        <h3 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-162">
          Y gracias a eso están logrando:
        </h3>

        <div className="space-y-4 mb-8" data-id="element-163">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-dark/50 p-4 rounded-lg border border-primary/20" data-id="element-164">
              <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mt-1" data-id="element-165" />
              <p className="text-lg font-semibold" data-id="element-166">{benefit}</p>
            </motion.div>)}
        </div>

        <p className="text-xl text-center font-bold text-accent" data-id="element-167">
          Sin trabajar más horas.
        </p>
      </div>
    </motion.section>;
}